/**
 * @generated SignedSource<<67b525b78f754217011228286778edeb>>
 * @relayHash 1f6255ab3d6cbf0509c74d31d44b1007
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 846d41437acd119298d75f90d9fb6c29bfcf8be06b48ead319d707a033a72077

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type csmRequestDetailsQuery$variables = {
  cloudId: string;
  helpCenterId: string;
  issueKey: string;
};
export type csmRequestDetailsQuery$data = {
  readonly customerService: {
    readonly requestByIssueKey: {
      readonly __typename: "CustomerServiceRequest";
      readonly " $fragmentSpreads": FragmentRefs<"formView_csmRequestDetails" | "header_csmRequestDetails">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type csmRequestDetailsQuery = {
  response: csmRequestDetailsQuery$data;
  variables: csmRequestDetailsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterId",
    "variableName": "helpCenterId"
  },
  {
    "kind": "Variable",
    "name": "issueKey",
    "variableName": "issueKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "question"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v4/*: any*/),
                "kind": "LinkedField",
                "name": "requestByIssueKey",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "header_csmRequestDetails"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "formView_csmRequestDetails"
                      }
                    ],
                    "type": "CustomerServiceRequest"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.requestByIssueKey"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "csmRequestDetailsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "requestByIssueKey",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "summary"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "createdOn"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "statusKey"
                  },
                  {
                    "concreteType": "CustomerServiceRequestFormDataConnection",
                    "kind": "LinkedField",
                    "name": "formData",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CustomerServiceRequestFormDataEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "textAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "adfAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryRichTextField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "multiSelectTextAnswer"
                                  }
                                ],
                                "type": "CustomerServiceRequestFormEntryMultiSelectField"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v6/*: any*/)
                ],
                "type": "CustomerServiceRequest"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "846d41437acd119298d75f90d9fb6c29bfcf8be06b48ead319d707a033a72077",
    "metadata": {},
    "name": "csmRequestDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "87a558fcd411fd5b7646b76bd10ad264";

export default node;
